import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountDetailsComponent } from './components/account-details/account-details.component';
import { AuthCallbackComponent } from './components/auth/auth-callback/auth-callback.component';
import { CardListItemComponent } from './components/cards/card-list-item/card-list-item.component';
import { MemberCardComponent } from './components/member-card/member-card.component';
import { SingleSignOnComponent } from './components/single-sign-on/single-sign-on.component';
import { UserLoginComponent } from './components/user-login/user-login.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { BarcodeComponent } from './components/barcode/barcode.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QRCodeModule } from 'angularx-qrcode';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AddressBookComponent } from './components/address-book/address-book.component';
import { TopUpAddressComponent } from './components/top-up-address/top-up-address.component';
import { PointsSummaryComponent } from './components/points-summary/points-summary.component';
import { EcashBalanceComponent } from './components/ecash-balance/ecash-balance.component';
import { RouterModule } from '@angular/router';
import { PointsSummaryBarComponent } from './components/points-summary-bar/points-summary-bar.component';
import { ContactsManagementComponent } from './components/contacts-management/contacts-management.component';
import { MlbamUserLoginComponent } from './components/mlbam-user-login/mlbam-user-login.component';
import { TransactionListComponent } from './components/transaction-list/transaction-list.component';
import { ReferAFriendComponent } from './components/refer-a-friend/refer-a-friend.component';
import { TransactionHistoryComponent } from './components/transaction-history/transaction-history.component';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { CardListComponent } from './components/cards/card-list/card-list.component';
import { PassesModule } from '../passes/passes.module';
import { CardSelectComponent } from './components/cards/card-select/card-select.component';
import { CardSelectMobileComponent } from './components/cards/card-select-mobile/card-select-mobile.component';
import { AddressSelectorComponent } from './components/address-selector/address-selector.component';
import { BalanceBarComponent } from './components/balance-bar/balance-bar.component';
import { PointsManagementPlaceholderComponent } from './components/points-management-placeholder/points-management-placeholder.component';
import { PointsTransferComponent } from './components/points-transfer/points-transfer.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { PartnerListComponent } from './components/partner-list/partner-list.component';
import { PartnerPendingListComponent } from './components/partner-pending-list/partner-pending-list.component';
import { PartnerAddFormComponent } from './components/partner-add-form/partner-add-form.component';
import { PartnerAcceptFormComponent } from './components/partner-accept-form/partner-accept-form.component';
import { AveragePointsComponent } from './components/average-points/average-points.component';
import { TmUserLoginComponent } from './components/tm-user-login/tm-user-login.component';
import { EditAccountDetailsComponent } from './components/edit-account-details/edit-account-details.component';
import { V1SingleSignOnComponent } from './components/v1-single-sign-on/v1-single-sign-on.component';
import { SportsAllianceUserLoginComponent } from './components/sports-alliance-user-login/sports-alliance-user-login.component';
import { GbgIdentityStatusComponent } from './components/gbg-identity-status/gbg-identity-status.component';
import { DateRangePickerModule } from '@fgb/portal-component-library/src/lib/shared/date-range-picker';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { LayoutModule } from '../layouts/layout.module';
import { ErrorsModule } from '@fgb/portal-component-library/src/lib/shared/errors';
import { SportsIllustratedUserLoginComponent } from './components/sports-illustrated-user-login copy/sports-illustrated-user-login.component';

@NgModule({
  declarations: [
    AccountDetailsComponent,
    AuthCallbackComponent,
    CardListItemComponent,
    MemberCardComponent,
    SingleSignOnComponent,
    UserLoginComponent,
    BarcodeComponent,
    TopUpAddressComponent,
    AddressBookComponent,
    EcashBalanceComponent,
    PointsSummaryComponent,
    PointsSummaryBarComponent,
    ContactsManagementComponent,
    MlbamUserLoginComponent,
    ReferAFriendComponent,
    TransactionListComponent,
    TransactionHistoryComponent,
    CardListComponent,
    CardSelectComponent,
    CardSelectMobileComponent,
    AddressSelectorComponent,
    BalanceBarComponent,
    PointsManagementPlaceholderComponent,
    PointsTransferComponent,
    PartnerListComponent,
    PartnerPendingListComponent,
    PartnerAddFormComponent,
    PartnerAcceptFormComponent,
    AveragePointsComponent,
    TmUserLoginComponent,
    EditAccountDetailsComponent,
    V1SingleSignOnComponent,
    SportsAllianceUserLoginComponent,
    GbgIdentityStatusComponent,
    SportsIllustratedUserLoginComponent,
  ],
  exports: [
    AccountDetailsComponent,
    AuthCallbackComponent,
    CardListItemComponent,
    MemberCardComponent,
    SingleSignOnComponent,
    UserLoginComponent,
    BarcodeComponent,
    TopUpAddressComponent,
    AddressBookComponent,
    EcashBalanceComponent,
    PointsSummaryComponent,
    PointsSummaryBarComponent,
    ContactsManagementComponent,
    MlbamUserLoginComponent,
    TransactionHistoryComponent,
    ReferAFriendComponent,
    CardListComponent,
    CardSelectComponent,
    CardSelectMobileComponent,
    AddressSelectorComponent,
    BalanceBarComponent,
    PointsManagementPlaceholderComponent,
    PointsTransferComponent,
    PartnerListComponent,
    PartnerPendingListComponent,
    PartnerAddFormComponent,
    PartnerAcceptFormComponent,
    AveragePointsComponent,
    TmUserLoginComponent,
    EditAccountDetailsComponent,
    V1SingleSignOnComponent,
    SportsAllianceUserLoginComponent,
    GbgIdentityStatusComponent,
    SportsIllustratedUserLoginComponent,
  ],
  imports: [
    NgbModule,
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    QRCodeModule,
    RouterModule,
    InlineSVGModule,
    PassesModule,
    CarouselModule,
    DateRangePickerModule,
    DirectivesModule,
    FGBSharedModule,
    LayoutModule,
    ErrorsModule,
  ],
})
export class UserModule {}
